const FormResources = {

    form_data:{
        survey_id: '',
        question: '',
        question_type_id: '',
        response_type: '',
        answers_data: [
            {
                answer_text: '',
            },
            {
                answer_text: '',
            },
            // {
            //     answer_text: '',
            // },
            // {
            //     answer_text: '',
            // },
            // {
            //     answer_text: '',
            // },
        ],
    },

    answers_data: [
        {
            id: '',
            answer_text: '',
        },
        {
            id: '',
            answer_text: '',
        },
        // {
        //     id: '',
        //     answer_text: '',
        // },
        // {
        //     id: '',
        //     answer_text: '',
        // },
        // {
        //     id: '',
        //     answer_text: '',
        // },
    ],

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Question:',
            model_name: 'question',
            ref:        'question_input',
            ref_alt:    'question_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Question type:',
            model_name: 'question_type_id',
            ref:        'question_type_id_input',
            ref_alt:    'question_type_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Response type:',
            model_name: 'response_type',
            ref:        'response_type_input',
            ref_alt:    'response_type_input_alt',
            required:   true,
        },
    ],

    send_survey_form_data:{
        survey_id: '',
        cost_center_id: '',
        cost_center_department_id: '',
        associate_id: [],
        subject: '',
        email_body: '',
        number: 1,
        random: false,
        survey_url: '',
    },

    send_survey_form_format:[
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Cost center:',
            model_name: 'cost_center_id',
            ref:        'cost_center_id_input',
            ref_alt:    'cost_center_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'select',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Department:',
            model_name: 'cost_center_department_id',
            ref:        'cost_center_department_id_input',
            ref_alt:    'cost_center_department_id_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Subject:',
            model_name: 'subject',
            ref:        'subject_input',
            ref_alt:    'subject_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Email body:',
            model_name: 'email_body',
            ref:        'email_body_input',
            ref_alt:    'email_body_input_alt',
            required:   true,
        },
    ],

    // send_survey_form_data_lite:{
    //     survey_id:                  '',
    //     associate_id:               [],
    //     subject:                    '',
    //     email_body:                 '',
    //     random:                     false,
    // },

    send_survey_form_format_lite:[
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Number of recipients:',
            model_name: 'number',
            ref:        'number_input',
            ref_alt:    'number_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  100,
            disabled:   false,
            step:       '',
            name:       'Subject:',
            model_name: 'subject',
            ref:        'subject_input',
            ref_alt:    'subject_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  500,
            disabled:   false,
            step:       '',
            name:       'Email body:',
            model_name: 'email_body',
            ref:        'email_body_input',
            ref_alt:    'email_body_input_alt',
            required:   true,
        },
    ],
            
    boolean_option:[
        {
            css_class:  'col-md-12',
            type:       'radio',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       '',
            model_name: 'random',
            ref:        'random_input',
            ref_alt:    'random_input_alt',
            required:   false,
            childs: [
                {
                    ref:   'manual_sync',
                    name:  'Manual selection',
                    value: false,
                },
                {
                    ref:   'random_sync',
                    name:  'Random selection',
                    value: true,
                },
            ]
        },
    ],

}

export default FormResources;